import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import store from '@/store'

Vue.use(Router)

// 验证token是否有效的辅助函数
function isValidToken(token) {
  if (!token) return false

  try {
    // 检查token格式和过期时间
    const payload = JSON.parse(atob(token.split('.')[1]))
    const now = Date.now() / 1000

    // 如果token已过期，返回false
    if (payload.exp && payload.exp < now) {
      return false
    }

    return true
  } catch (error) {
    // 如果token格式不正确，返回false
    return false
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/layout/home'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login'),
      meta: { requiresAuth: false }
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/Register'),
      meta: { requiresAuth: false }
    },
    {
      path: '/layout',
      component: () => import('@/layout/Layout'),
      meta: { requiresAuth: true },
      redirect: '/layout/home',
      children: [
        {
          path: 'home',
          name: 'Home',
          component: () => import('@/views/Home'),
          meta: { title: '首页' }
        },
        {
          path: 'synthesis',
          name: 'Synthesis',
          component: () => import('@/views/Synthesis'),
          meta: { title: '语音合成' }
        },
        {
          path: 'records',
          name: 'Records',
          component: () => import('@/views/Records'),
          meta: { title: '合成记录' }
        },
        {
          path: 'profile',
          name: 'Profile',
          component: () => import('@/views/Profile'),
          meta: { title: '个人中心' }
        },
        {
          path: 'shop',
          name: 'Shop',
          component: () => import('@/views/Shop'),
          meta: { title: '积分商城' }
        }
      ]
    },
    // 兼容旧路由，重定向到新路由
    {
      path: '/home',
      redirect: '/layout/home'
    },
    {
      path: '/synthesis',
      redirect: '/layout/synthesis'
    },
    {
      path: '/records',
      redirect: '/layout/records'
    },
    {
      path: '/profile',
      redirect: '/layout/profile'
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = Cookies.get('token')
  const isTokenValid = isValidToken(token)

  // 如果访问的是需要认证的路由但没有有效token，跳转到登录页
  if (to.meta.requiresAuth !== false && !isTokenValid) {
    // 清除无效的用户信息
    Cookies.remove('user')
    Cookies.remove('token')
    store.dispatch('logout')

    // 显示未授权消息
    if (to.path !== '/login' && to.path !== '/register') {
      // 使用setTimeout确保消息在路由跳转后显示
      setTimeout(() => {
        const { Message } = require('element-ui')
        Message.error('登录已过期或无访问权限，请重新登录')
      }, 100)
    }

    // 保存原始路径，登录后可以跳转回来
    const redirect = to.fullPath
    next({
      path: '/login',
      query: redirect !== '/login' && redirect !== '/register' ? { redirect } : {}
    })
  } else if ((to.path === '/login' || to.path === '/register') && isTokenValid) {
    // 如果已登录但访问登录或注册页，跳转到首页
    next('/layout/home')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js